import React, { useCallback } from 'react';
import { Link } from '../../Link';
import { Box } from '../../Box';
import { TabItemCounter } from './TabItemCounter';
import { ILinkComponent, IOption } from '@src/models/props';
import { IItemClassName } from '../models';
import { AnyType } from '@src/models/common';
import { classnames } from '@src/utils/classnames';
import styled from '../Tab.module.scss';
import { onUnitClickCallback } from '@src/core/Unit';

interface ITabItemProps<TValue> extends ILinkComponent, IOption<TValue>, IItemClassName {
  active?: boolean;
  onChange: (v: TValue) => void;
}

export const TabItem = <TValue extends AnyType = AnyType>({
  label,
  value,
  href,
  active,
  count,
  itemClassName,
  disableNextJs,
  onChange,
  onClick,
  ...rest
}: ITabItemProps<TValue>) => {
  const classes = classnames(styled.item, itemClassName, {
    [styled.active]: active,
  });

  const handleClick = useCallback(
    (e) => {
      onChange(value);
      onClick?.(e);
    },
    [onChange, onClick, value],
  );

  const dataId = 'tab_item_' + value;

  return (
    <Link.Wrapper id={'tab_link_' + value} href={href} disableNextJs={disableNextJs} {...rest}>
      <Box key={value as AnyType} className={classes} id={dataId}>
        <Box onClick={onUnitClickCallback(dataId, handleClick)}>
          {label}
          {!!count && <TabItemCounter count={count} />}
        </Box>
      </Box>
    </Link.Wrapper>
  );
};
